import { render, staticRenderFns } from "./InsFooterLayout.vue?vue&type=template&id=ca869a08&scoped=true"
import script from "./InsFooterLayout.vue?vue&type=script&lang=ts"
export * from "./InsFooterLayout.vue?vue&type=script&lang=ts"
import style0 from "./InsFooterLayout.vue?vue&type=style&index=0&id=ca869a08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca869a08",
  null
  
)

export default component.exports